module.exports = __webpack_public_path__ + "img/logo.0bcc8036.png";